<template>
    <div class="index">
        <pc>
            <qHeader></qHeader>
            <el-container>
                <el-row>
                    <el-col :span="6">
                        <COP></COP>
                        <l-echarts></l-echarts>
                        <water></water>
                    </el-col>
                    <el-col :span="12">
                        <qimage></qimage>
                    </el-col>
                    <el-col :span="6">
                        <top-card></top-card>
                        <working></working>
                        <r-echarts></r-echarts>
                        <r-table></r-table>
                    </el-col>
                </el-row>
            </el-container>
            <div class="foot"></div>
        </pc>
    </div>
</template>
<script>
// 引入组件
import pc from "@/components/cockpit/pc.vue";
import qHeader from "@/components/cockpit/header.vue";
import COP from "@/components/cockpit/COP.vue";
import water from "@/components/cockpit/water.vue";
import topCard from "@/components/cockpit/top-card.vue";
import working from "@/components/cockpit/working.vue";
import rEcharts from "@/components/cockpit/right-echarts.vue";
import lEcharts from "@/components/cockpit/left-echarts.vue";
import rTable from "@/components/cockpit/right-table.vue";
import qimage from "@/components/cockpit/image.vue";

export default {
    data() {
        return {
        }
    },
    // 注册组件
    components: {
        pc,
        qHeader,
        COP,
        water,
        topCard,
        working,
        rEcharts,
        lEcharts,
        rTable,
        qimage
    },
    methods: {
        // handleBack(){
        //     console.log("1111111111");

        // }
        // 自动全屏
        fullscreenCheck() {
            if (!document.fullscreenElement &&
                !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {  // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) {
                    document.documentElement.msRequestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            }
            /*  else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            } */
        }
    },
    mounted() {
        // this.handleServe()

        // 自动全屏
        this.fullscreenCheck()

        // 抬起esc退出
        this.$nextTick(() => {
            document.onkeyup = (e) => {
                // console.log(e);
                //此处填写你的业务逻辑即可
                if (e.key == "Escape") {
                    this.$router.back()
                }
            }
        })

    },
}
</script>
<style lang="less" scoped>
.index::v-deep {
    background-color: #051C55;
    position: fixed;
    right: 0;
    top: 0;
    left: 0;
    bottom: 0;

    // width: 1920px;
    // height: 1080px;

    .el-container {
        height: 100%;
        overflow: hidden;

        .el-row {
            width: 100%;
            display: flex;

            .el-col {
                &:nth-child(1) {
                    margin: 0 20px 0 30px;
                    width: calc((100% - 940px - 40px - 60px)/2);
                }

                &:nth-child(2) {
                    width: 940px;
                }

                &:nth-child(3) {
                    margin: 0 30px 0 20px;
                    width: calc((100% - 940px - 40px - 60px)/2);
                }
            }

        }
    }

    .foot {
        width: 100%;
        height: 25px;
        background-image: url(@/assets/images/cockpit/foot.png);
        background-size: contain;
        background-repeat: no-repeat;
        position: fixed;
        bottom: 0;
    }
}
</style>